import { FetchError } from './FetchError';
import { FETCH_TRANSFORMER_ERROR_CODE } from 'utils';

/**
 * Authentication/authorization errors (401, 403, token issues)
 *
 * @example
 * ```typescript
 * throw new AuthError('Token expired', 401, { tokenAge: 3600 });
 * ```
 */
export class AuthError extends FetchError {
  override readonly type = 'AuthError';

  constructor(message: string, statusCode: number, details?: Record<string, unknown>, cause?: Error) {
    super(message, FETCH_TRANSFORMER_ERROR_CODE.AUTH_ERROR, statusCode, details, cause);
  }
}
